import { useMemo } from "react"
import { PinIcon } from "shared/icons"
import { colors } from "shared/colors"

import { Box, Stack, Typography, ListItem, Chip, ListItemButton, Tooltip } from "@mui/material"

import { Section } from 'components/controls/section'
import { LogResult } from 'interface/kojin/log'

//const fullTrim = (text: string) => text.replace(/(?:(?:^|\n)\s+|\s+(?:$|\n))|\(|\)/g,'').replace(/\s+/g,'')
//const cleanHtmlChars = (text: string) => text.replace(/&(.*?);/g,'')
const strip = (text: string) => text.replace(/<[^>]*>?/gm, '')

const ServicePin = ({
  service
}: {
  service: string
}) => service === 'news' ? (
  <Tooltip title="NEWS"><PinIcon style={{ color: colors.news.main }}/></Tooltip>
) : service === 'kiji' ? (
  <Tooltip title="記事"><PinIcon style={{ color: colors.news.main }}/></Tooltip>
) : service === 'slide' ? (
  <Tooltip title="スライド"><PinIcon style={{ color: colors.news.main }}/></Tooltip>
) : service === 'drsPicksNews' ? (
  <Tooltip title="DrsPicks"><PinIcon style={{ color: colors.picks.main }}/></Tooltip>
) : (service === 'mrplus' || service === 'mrplus_client') ? (
  <Tooltip title="MRP"><PinIcon style={{ color: colors.mrp.main }}/></Tooltip>
) : service === 'live' ? (
  <Tooltip title="講演会"><PinIcon style={{ color: colors.live.main }}/></Tooltip>
) : service === 'dvd' ? (
  <Chip size="small" label="DVD"/>
) : service === 'drug' ? (
  <Chip size="small" label="薬品検索"/>
) : service === 'other' ? (
  <Chip size="small" label="その他"/>
) : (
  <Chip size="small" label={service}/>
)

export const LogRecord = (props: {
  dateLabel: string
  log: LogResult
  isSmallMedia: boolean
}) => {
  const { dateLabel, log, isSmallMedia } = props
  const linkTo = useMemo(
    () => {
      return log.url.startsWith('com:') ? (
        `https://www.carenet.com${log.url.substring('com:'.length)}`
      ) : log.url.startsWith('dp:') ? (
        `https://drpicks.carenet.com/d/dpview/news?news_id=${log.serviceId}`
      ) : log.url.startsWith('mrp:') ? (
        `https://mrp.carenet.com${log.url.substring('mrp:'.length)}`
      ) : log.url.startsWith('live: ') ? (
        `https://seminar.carenet.com/lv/live/${log.url.substring('live: '.length)}`
      ) : undefined
    },
    [log]
  )
  return (
    <ListItem disablePadding>
      {isSmallMedia ? (
        <ListItemButton href={linkTo ?? 'void(0)'} target="_blank" sx={{ paddingY: 0.5, paddingX: 1 }}>
          <Box width="100%">
            <Typography variant="body2" component="div">{dateLabel}</Typography>
            <Stack direction='row' spacing={0.5} justifyContent='flex-start' width='100%'>
              <ServicePin service={log.service}/>
              <Stack flexGrow={1} direction='row' spacing={1} justifyContent='flex-end' flexWrap="wrap">
                <Typography variant="body2" component="div" flexGrow={1}>{log.title ? strip(log.title) : 'no title'}</Typography>
                <Stack direction='row' spacing={1}>
                  {log.clientName && <Typography variant="body2">{log.clientName}</Typography>}
                  {log.tags.drug?.map((tag, i) => <Typography key={`drug-${i}`} variant="body2" color="success">{tag}</Typography>)}
                </Stack>
              </Stack>
            </Stack>
          </Box>
        </ListItemButton>
      ) : (
        <Section label={dateLabel} labelWidth='8em' disablePadding labelProps={{ paddingY: 0.5, paddingX: 1 }}>
          <ListItemButton href={linkTo ?? 'void(0)'} target="_blank" sx={{ paddingY: 0.5, paddingX: 1 }}>
            <Stack direction='row' spacing={0.5} width='100%'>
              <ServicePin service={log.service}/>
              <Stack flexGrow={1} direction='row' spacing={1} justifyContent='flex-end' flexWrap="wrap">
                <Typography variant="body2" component="span" flexGrow={1}>{log.title ? strip(log.title) : 'no title'}</Typography>
                <Stack direction='row' spacing={1}>
                  {log.clientName && <Typography component="span" variant="body2">{log.clientName}</Typography>}
                  {log.tags.drug?.map((tag, i) => <Typography key={`drug-${i}`} component="span" variant="body2" color="success">{tag}</Typography>)}
                </Stack>
              </Stack>
            </Stack>
          </ListItemButton>
        </Section>
      )}
    </ListItem>
  )
}
